import { render, staticRenderFns } from "./MTags.vue?vue&type=template&id=f3816ae8"
import script from "./MTags.vue?vue&type=script&lang=js"
export * from "./MTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports